import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export const useLang = () => useContext(LanguageContext);

export const ui = {
  nav: {
    home: { fr: 'Accueil', en: 'Home' },
    about: { fr: 'À propos', en: 'About' },
    services: { fr: 'Services', en: 'Services' },
    team: { fr: 'Équipe', en: 'Team' },
    contact: { fr: 'Contact', en: 'Contact' },
  },
  cta: {
    contact: { fr: 'Nous joindre', en: 'Contact us' },
    discover: { fr: 'Découvrir nos services', en: 'Discover our services' },
    allServices: { fr: 'Tous les services', en: 'All services' },
    meetTeam: { fr: 'Rencontrer l\u2019équipe', en: 'Meet the team' },
    learnMore: { fr: 'En savoir plus', en: 'Learn more' },
    bookConsult: { fr: 'Prendre rendez-vous', en: 'Book a consultation' },
    backToServices: { fr: 'Retour aux services', en: 'Back to services' },
    backToTeam: { fr: 'Retour à l\u2019équipe', en: 'Back to the team' },
    sendMessage: { fr: 'Envoyer le message', en: 'Send message' },
  },
  home: {
    heroTag: { fr: 'Depuis 2016', en: 'Since 2016' },
    heroTitle: { fr: 'Un même toit pour toute votre famille', en: 'One roof for your whole family' },
    heroSub: {
      fr: 'Une équipe multidisciplinaire réunissant le monde psychosocial et juridique pour accompagner les familles à chaque transition de vie.',
      en: 'A multidisciplinary team uniting psychosocial and legal expertise to support families through every life transition.'
    },
    statsFamilies: { fr: 'Familles accompagnées', en: 'Families supported' },
    statsYears: { fr: 'Années d\u2019expérience', en: 'Years of experience' },
    statsServices: { fr: 'Services spécialisés', en: 'Specialized services' },
    servicesTag: { fr: 'Nos domaines', en: 'Our fields' },
    servicesTitle: { fr: 'Des services sous un même toit', en: 'Services under one roof' },
    servicesIntro: {
      fr: 'Que ce soit pour un besoin juridique, une médiation, une thérapie ou un soutien en milieu scolaire, nos experts sont là pour vous, sans jugement.',
      en: 'Whether you need legal advice, mediation, therapy or school support, our experts are here for you, without judgment.'
    },
    approachTag: { fr: 'Notre approche', en: 'Our approach' },
    approachTitle: { fr: 'Vous écouter, vous guider, vous accompagner', en: 'Listening, guiding and supporting you' },
    ctaTitle: { fr: 'Traversons ce nouveau pont ensemble', en: 'Let us cross this new bridge together' },
    ctaSub: {
      fr: 'Toute l\u2019équipe du Centre d\u2019expertise familiale est impatiente de vous entendre.',
      en: 'The whole Family Expertise Centre team looks forward to hearing from you.'
    },
  },
  services: {
    tag: { fr: 'Nos services', en: 'Our services' },
    title: { fr: 'Un accompagnement complet', en: 'Complete support' },
    intro: {
      fr: 'Notre équipe met à votre disposition une gamme complète de services et de professionnels pour accompagner les personnes qui vivent plusieurs difficultés.',
      en: 'Our team offers a full range of services and professionals to support people facing various challenges.'
    },
    relatedTitle: { fr: 'Autres services', en: 'Other services' },
  },
  team: {
    tag: { fr: 'Notre équipe', en: 'Our team' },
    title: { fr: 'Des professionnels dévoués', en: 'Dedicated professionals' },
    intro: {
      fr: 'Une équipe multidisciplinaire de professionnels psychosociaux et de juristes réunie pour vous.',
      en: 'A multidisciplinary team of psychosocial and legal professionals gathered for you.'
    },
    contactMember: { fr: 'Coordonnées', en: 'Contact details' },
    expertise: { fr: 'Domaines d\u2019expertise', en: 'Areas of expertise' },
    about: { fr: 'À propos', en: 'About' },
    servicesOffered: { fr: 'Services offerts', en: 'Services offered' },
    learnMore: { fr: 'Pour en savoir plus', en: 'Learn more' },
    visitWebsite: { fr: 'Visiter le site web', en: 'Visit website' },
  },
  contact: {
    tag: { fr: 'Contact', en: 'Contact' },
    title: { fr: 'Nous joindre', en: 'Get in touch' },
    intro: {
      fr: 'Si vous avez des questions, des commentaires ou souhaitez en savoir plus sur nos services, n\u2019hésitez pas à nous contacter.',
      en: 'If you have questions, comments or would like to learn more about our services, please do not hesitate to contact us.'
    },
    address: { fr: 'Adresse', en: 'Address' },
    phone: { fr: 'Téléphone', en: 'Phone' },
    email: { fr: 'Courriel', en: 'Email' },
    hours: { fr: 'Heures d\u2019ouverture', en: 'Opening hours' },
    formName: { fr: 'Nom complet', en: 'Full name' },
    formEmail: { fr: 'Courriel', en: 'Email' },
    formPhone: { fr: 'Téléphone', en: 'Phone' },
    formSubject: { fr: 'Sujet', en: 'Subject' },
    formMessage: { fr: 'Votre message', en: 'Your message' },
    formSuccess: { fr: 'Merci ! Votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.', en: 'Thank you! Your message has been sent. We will get back to you shortly.' },
    hoursValue: { fr: 'Lundi au vendredi : 9 h à 17 h', en: 'Monday to Friday: 9 a.m. to 5 p.m.' },
  },
  footer: {
    tagline: { fr: 'Réunir le psychosocial et le juridique sous un même toit depuis 2016.', en: 'Uniting psychosocial and legal expertise under one roof since 2016.' },
    quickLinks: { fr: 'Navigation', en: 'Navigation' },
    servicesTitle: { fr: 'Services', en: 'Services' },
    contactTitle: { fr: 'Coordonnées', en: 'Contact' },
    privacy: { fr: 'Politique de confidentialité', en: 'Privacy policy' },
    rights: { fr: 'Tous droits réservés.', en: 'All rights reserved.' },
    placeholderNote: { fr: 'Coordonnées à confirmer', en: 'Details to be confirmed' },
  },
  privacy: {
    tag: { fr: 'Confidentialité', en: 'Confidentiality' },
    title: { fr: 'Politique de confidentialité et de protection des renseignements personnels', en: 'Privacy and personal information protection policy' },
  },
  cookies: {
    title: { fr: 'Votre vie privée', en: 'Your privacy' },
    message: {
      fr: 'Ce site utilise uniquement les témoins nécessaires à son bon fonctionnement. Avec votre consentement, nous pourrions aussi utiliser des témoins de mesure d\u2019audience afin d\u2019améliorer votre expérience. Vous pouvez accepter ou refuser librement.',
      en: 'This site only uses cookies necessary for its proper functioning. With your consent, we may also use audience-measurement cookies to improve your experience. You are free to accept or decline.',
    },
    accept: { fr: 'Accepter', en: 'Accept' },
    refuse: { fr: 'Refuser', en: 'Decline' },
    learnMore: { fr: 'En savoir plus', en: 'Learn more' },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('fr');
  const toggle = useCallback(() => setLang((l) => (l === 'fr' ? 'en' : 'fr')), []);
  const t = useCallback((node) => (node && node[lang] !== undefined ? node[lang] : ''), [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
